import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-background-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <button onClick={() => navigate("/")} className="flex items-center gap-2 cursor-pointer">
            <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-xs">
              O
            </div>
            <span className="text-background-100 font-medium text-sm">OOPBuy Spreadsheet</span>
          </button>
          <p className="text-background-500 text-xs">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet Forum. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
}